<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item 
            :class="className"
            label="" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="value" hidden="hidden" />
        </el-form-item>
    </el-col>
</template>
<script>
    import baseField from "./BaseComputedObjectField" 
    export default {
        name:"ComputedObjectField",
        mixins:[baseField]
    }
</script>
